<template>
    <!-- 表单提交、取消按键  容器右下角-->
    <div class="button_corner">
      <div id="comboBtn">
        <!-- 取消按键 -->
        <el-button color="#00D8C3" plain @click="cancel">取消</el-button>
        <!-- 确定按键 传递函数 -->
        <el-button color="#139BA5" type="primary" @click="confirm">确认</el-button>
      </div>
    </div>
</template>

<script>

export default {
  name: 'RightCornerButtons',
  emits: ['confirm'],
  methods: {
    // 点击取消
    cancel () {
      this.$confirm('您的修改将不会保存,确定后将返回上一页。', '是否放弃修改？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 点击确定后，清空路由缓存，退回前一页
        // this.clearCache(this.$store.state.router)
        this.$router.go(-1)
        // this.$global.remove_pageTabs(this.$store.state.router)
      }).catch(() => {})
    },
    // 点击确认
    confirm () {
      this.$confirm('点击确认将上传您的修改', '是否保存？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 传递确定函数
        this.$emit('confirm')
      }).catch(() => {})
    },
    // 清除路由缓存
    clearCache (key) {
      // 获取当前路由的key值
      const tabs = this.$store.state.pageTabs
      const index = tabs.findIndex(tab => tab.key === key)
      // 通过key值清除路由缓存
      if (index !== -1) {
        this.$store.commit('removeCachePages', tabs[index].name)
      }
    }
  }
}
</script>

<style scoped>
.button_corner{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
}
/deep/ .el-button.is-plain:focus, .el-button.is-plain:hover{
  border-color: #00D8C3;
  color: #00D8C3;
}
</style>
